import { z } from "zod";

export const customerOrderEmailSchema = z
  .string()
  .trim()
  .toLowerCase()
  .pipe(
    z
      .email()
      .max(254)
      .regex(/^[^\s"'\\():]+$/),
  );
export const emailCodeSendRequestSchema = z.strictObject({
  uid: z.string().min(1).max(256),
  email: customerOrderEmailSchema,
  conversation_id: z.string().min(1).max(128).optional(),
});
export const emailCodeVerifyRequestSchema = emailCodeSendRequestSchema
  .extend({
    email: customerOrderEmailSchema.optional(),
    challenge_id: z.string().min(1).max(128).optional(),
    code: z.string().regex(/^\d{6}$/),
  })
  .refine((value) => !!value.email || !!value.challenge_id);
export const emailCodeResponseSchema = z.strictObject({
  status: z.enum([
    "accepted",
    "failed",
    "unknown",
    "not_configured",
    "cooldown",
    "locked",
    "wrong",
    "expired",
    "verified",
    "not_accessible",
  ]),
  retry_after: z.int().nonnegative(),
  tries_left: z.int().nonnegative(),
});
export type EmailCodeResponse = z.infer<typeof emailCodeResponseSchema>;
export const pendingEmailCodeSchema = z.object({
  challenge_id: z.string().min(1).max(128),
  masked_email: z.string(),
  expires_at: z.iso.datetime(),
  retry_after: z.int().nonnegative(),
  tries_left: z.int().nonnegative(),
});
